import JSEncryptLong from 'encryptlong/bin/jsencrypt'
/***************数据密钥***********************************/
//公钥
const PUBLIC_DATA_KEY = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD\n' +
'2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ==';
//私钥
const PRIVATE_DATA_KEY = 'MIIBUwIBADANBgkqhkiG9w0BAQEFAASCAT0wggE5AgEAAkEA0vfvyTdGJkdbHkB8\n' +
'mp0f3FE0GYP3AYPaJF7jUd1M0XxFSE2ceK3k2kw20YvQ09NJKk+OMjWQl9WitG9p\n' +
'B6tSCQIDAQABAkA2SimBrWC2/wvauBuYqjCFwLvYiRYqZKThUS3MZlebXJiLB+Ue\n' +
'/gUifAAKIg1avttUZsHBHrop4qfJCwAI0+YRAiEA+W3NK/RaXtnRqmoUUkb59zsZ\n' +
'UBLpvZgQPfj1MhyHDz0CIQDYhsAhPJ3mgS64NbUZmGWuuNKp5coY2GIj/zYDMJp6\n' +
'vQIgUueLFXv/eZ1ekgz2Oi67MNCk5jeTF2BurZqNLR3MSmUCIFT3Q6uHMtsB9Eha\n' +
'4u7hS31tj1UWE+D+ADzp59MGnoftAiBeHT7gDMuqeJHPL4b+kC+gzV4FGTfhR9q3\n' +
'tTbklZkD2A==';
/* 加密 */
export function encryptLong(data) {
    var encryptor = new JSEncryptLong()
	encryptor.setPublicKey(PUBLIC_DATA_KEY);
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    const result = encryptor.encryptLong(data)
    return result
}
/**
 * 解密
 * @param {Object} data
 */
export function decryptLong(data) {
    var encryptor = new JSEncryptLong()
    encryptor.setPrivateKey(PRIVATE_DATA_KEY)
    var result = encryptor.decryptLong(data)
    return result
}
// token
export function syShopSign() {
  const sign = '1oOP3ykFDI0K6ifmtvU7c8Y1eTWZSlyl'

  return sign
}



// WEBPACK FOOTER //
// ./src/utils/rsaEncrypt.js